import React, { useState, useEffect } from "react";
import { Sparkles } from "lucide-react";

const QUOTES = [
  { text: "Education is the most powerful weapon which you can use to change the world.", author: "Nelson Mandela" },
  { text: "The beautiful thing about learning is that nobody can take it away from you.", author: "B.B. King" },
  { text: "Knowledge is like a garden: if it is not cultivated, it cannot be harvested.", author: "Ghanaian Proverb" },
  { text: "It is not the mountain we conquer, but ourselves.", author: "Edmund Hillary" },
  { text: "If you want to go fast, go alone. If you want to go far, go together.", author: "African Proverb" },
  { text: "The roots of education are bitter, but the fruit is sweet.", author: "Aristotle" },
  { text: "By the time the fool has learned the game, the players have dispersed.", author: "Ghanaian Proverb" },
  { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
  { text: "A child who asks questions does not become a fool.", author: "Akan Proverb" },
  { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
  { text: "When the music changes, so does the dance.", author: "Hausa Proverb" },
  { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
  { text: "One who bathes willingly with cold water doesn't feel the cold.", author: "Fante Proverb" },
  { text: "Tell me and I forget. Teach me and I remember. Involve me and I learn.", author: "Benjamin Franklin" },
  { text: "Wisdom is not like money, to be tied up and hidden.", author: "Akan Proverb" },
  { text: "A person who never made a mistake never tried anything new.", author: "Albert Einstein" },
  { text: "The lizard that jumped from the high iroko tree said he would praise himself if no one else did.", author: "Igbo Proverb" },
  { text: "Live as if you were to die tomorrow. Learn as if you were to live forever.", author: "Mahatma Gandhi" },
  { text: "Rain does not fall on one roof alone.", author: "Cameroon Proverb" },
  { text: "No matter how long the night, the day is sure to come.", author: "Congolese Proverb" },
  { text: "Strive not to be a success, but rather to be of value.", author: "Albert Einstein" },
  { text: "However long the moon disappears, someday it must shine again.", author: "African Proverb" },
  { text: "The future belongs to those who believe in the beauty of their dreams.", author: "Eleanor Roosevelt" },
  { text: "Smooth seas do not make skilful sailors.", author: "African Proverb" },
  { text: "Do not look where you fell, but where you slipped.", author: "Liberian Proverb" },
  { text: "A single bracelet does not jingle.", author: "Congolese Proverb" },
  { text: "He who learns, teaches.", author: "Ethiopian Proverb" },
  { text: "The sun does not forget a village just because it is small.", author: "African Proverb" },
  { text: "Only a fool tests the depth of a river with both feet.", author: "African Proverb" },
  { text: "What you do today can improve all your tomorrows.", author: "Ralph Marston" },
];

export const DailyQuote = () => {
  const [quote, setQuote] = useState(null);

  useEffect(() => {
    const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0)) / 86400000);
    setQuote(QUOTES[dayOfYear % QUOTES.length]);
  }, []);

  if (!quote) return null;

  return (
    <div className="bg-gradient-to-r from-[#002147] to-[#0a3d7a] rounded-xl p-4 mb-6 shadow-md" data-testid="daily-quote">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 bg-[#FF6B00] rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
          <Sparkles size={16} className="text-white" />
        </div>
        <div>
          <p className="text-white/90 text-sm italic leading-relaxed">"{quote.text}"</p>
          <p className="text-white/50 text-xs mt-1.5">— {quote.author}</p>
        </div>
      </div>
    </div>
  );
};

export default DailyQuote;
